var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.maclass},[_vm._v(_vm._s(_vm.formatNumber())+"\n  "),(_vm.showCurrency)?_c('span',{class:_vm.maclass},[_vm._v(_vm._s(_vm.currency))]):_vm._e(),(_vm.showPercentage)?_c('span',{class:_vm.maclass},[_vm._v("%")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }